import {NewviewOaBaseApi} from "./NewviewOaBaseApi";


export class PurchaseApplyItemApi extends NewviewOaBaseApi {

  public get ControllerName(): any {
    return 'purchaseApplyItem'
  }

}